export default __webpack_public_path__ + "static/Amanda_Barrafato_Resume-7f2067a233beaf8bd3806e5e0026a2c9.pdf";